import 'jquery-viewport-checker';
import {isMobile} from "./utils";

if ($('.js-anim').length > 0) {
    $('.js-anim').viewportChecker();
}

window.addBlur = function () {
    if (!isMobile()) {
        $('.b-catalog').addClass('blur-back');
    }
}
window.removeBlur = function () {
    $('.b-catalog').removeClass('blur-back');
}
window.addMainBlur = function () {
    if (!isMobile()) {
        $('#main').addClass('blur-back');
    }
}
window.removeMainBlur = function () {
    $('#main').removeClass('blur-back');
}